"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const createGroupChat_1 = __importDefault(require("./createGroupChat"));
const sendDirectMessage_1 = __importDefault(require("./sendDirectMessage"));
const sendMessage_1 = __importDefault(require("./sendMessage"));
const markRead_1 = __importDefault(require("./markRead"));
const addParticipants_1 = __importDefault(require("./addParticipants"));
const removeParticipant_1 = __importDefault(require("./removeParticipant"));
const getUpdates_1 = __importDefault(require("./getUpdates"));
const getMessages_1 = __importStar(require("./getMessages"));
const searchAllMessages_1 = __importDefault(require("./searchAllMessages"));
const leaveGroup_1 = __importDefault(require("./leaveGroup"));
const joinGroup_1 = __importDefault(require("./joinGroup"));
const blockUser_1 = __importDefault(require("./blockUser"));
const toggleNotifications_1 = __importDefault(require("./toggleNotifications"));
class service {
    static createGroupChat(chatId, subject, users, chatHistoryVisibleToNewJoiners) {
        return createGroupChat_1.default(chatId, subject, users, chatHistoryVisibleToNewJoiners);
    }
    static sendDirectMessage(userId, senderName, clientMessageId, content, repliesTo) {
        return sendDirectMessage_1.default(userId, senderName, clientMessageId, content, repliesTo);
    }
    static sendMessage(chatId, senderName, clientMessageId, content, repliesTo) {
        return sendMessage_1.default(chatId, senderName, clientMessageId, content, repliesTo);
    }
    static markRead(chatId, fromId, toId) {
        return markRead_1.default(chatId, fromId, toId);
    }
    static addParticipants(chatId, users) {
        return addParticipants_1.default(chatId, users);
    }
    static removeParticipant(chatId, userId) {
        return removeParticipant_1.default(chatId, userId);
    }
    static leaveGroup(chatId) {
        return leaveGroup_1.default(chatId);
    }
    static joinGroup(chatId) {
        return joinGroup_1.default(chatId);
    }
    static blockUser(userId, unblock) {
        return blockUser_1.default(userId, unblock);
    }
    static getUpdates(request) {
        return getUpdates_1.default(request);
    }
    static getMessages(chatId, fromId, pageSize) {
        return getMessages_1.default(chatId, fromId, pageSize);
    }
    static getMessagesById(chatId, ids) {
        return getMessages_1.getMessagesById(chatId, ids);
    }
    static searchAllMessages(searchTerm, maxResults) {
        return searchAllMessages_1.default(searchTerm, maxResults);
    }
    static toggle_notifications(chatId, mute) {
        return toggleNotifications_1.default(chatId, mute);
    }
}
exports.default = service;
